module.exports = __webpack_public_path__ + "media/payment_options/discover-3bd0f0fd.png";